module.exports = __webpack_public_path__ + "static/q7-1348ba184a8e6ec91d711aef0b85242a.png";